import { ProfileReportRequestDto } from '@diritto/common/account/dtos/profile-report.dtos';
import { MutateFn } from '@diritto/common/base/mutateFunction';
import { useMutation } from '@tanstack/react-query';
import { ProfileReportApi } from 'api/ApiHelper';
import { accountsQueryKey } from 'queries/account/queryKey';

export const useMutateReportProfileQuery = (profileId: number, callback: MutateFn) =>
  useMutation({
    mutationKey: accountsQueryKey.reportProfile(profileId),
    mutationFn: (profileReportDto: ProfileReportRequestDto) =>
      ProfileReportApi.reportProfile(profileId, profileReportDto),
    onMutate: callback.onMutate,
    onSuccess: callback.onSuccess,
    onError: callback.onError,
  });
